import React, { useEffect, useState } from "react";
import LabReportTable from "./LabReportTable";
import FilterIcon from "../../../assets/images/Svg/FilterIcon.svg";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Select } from "antd";
import LabFilter from "./LabFilter";
import Layout from "../../../Layout";
import PatientService from "../../../Services/PatientService";
import { MdFamilyRestroom } from "react-icons/md";

function MyLabReports() {
  const [filterValues, setFilterValues] = useState(null);
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const patJson = sessionStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [selectedPatient, setSelectedPatient] = useState(patObj);
  const [famList, setFamList] = useState([]);

  useEffect(() => {
    getFamilyList();
  }, []);

  const handleFilter = () => {
    if (filterValues) {
      setFilterValues(null);
    } else {
      setIsModalOpen1(true);
    }
  };

  const handleCloseModal = (values) => {
    setFilterValues(values || null);
    setIsModalOpen1(false);
  };

  const getFamilyList = async () => {
    const payload = {
      parentPatientId: patObj?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handlePatientChange = (value) => {
    if (value === patObj.patientId) {
      setSelectedPatient(patObj);
    } else {
      const selectedPatObj = famList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };

  return (
    <Layout>
      <div className="p-4">
        <div className="flex sm:flex-col justify-between">
          <div className="font-bold text-xl sm:text-sm">My Lab Reports</div>
          <div className="flex  gap-3">
            {!patObj?.parentPatientId && (
              <div className="flex items-center gap-2 mb-3">
                <MdFamilyRestroom className="text-iconBlue" />
                <Select
                  className="w-36 h-9"
                  value={selectedPatient.patientId}
                  onChange={handlePatientChange}
                >
                  <Select.Option value={patObj?.patientId}>
                    {patObj.firstName}
                  </Select.Option>
                  {famList.length !== 0 &&
                    famList.map((fam) => (
                      <Select.Option value={fam.patientId}>
                        {fam.firstName}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            )}
            <Button
              className="w-20 h-9 px-2 flex items-center gap-2 custom_filter"
              onClick={handleFilter}
            >
              {filterValues ? (
                <div className="flex items-center">
                  <span className="text-white mx-1">Clear</span>
                  <CloseOutlined
                    style={{ color: "white", marginLeft: "4px" }}
                  />
                </div>
              ) : (
                <div className="flex items-center">
                  <span>
                    <img src={FilterIcon} alt="Icon" />
                  </span>
                  <span className="text-white ml-2">Filter</span>
                </div>
              )}
            </Button>
          </div>
        </div>
        <div>
          <LabReportTable
            selectedPatient={
              selectedPatient ? selectedPatient : patObj?.patientId
            }
            filterValues={filterValues}
          />
        </div>
      </div>

      {isModalOpen1 && (
        <Modal
          title={
            <span className="text-base font-bold font-sans">
              Lab Report Filter
            </span>
          }
          visible={isModalOpen1}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={500}
          maskClosable={false}
        >
          <LabFilter onClose={(values) => handleCloseModal(values)} />
        </Modal>
      )}
    </Layout>
  );
}

export default MyLabReports;
